/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPlaceholderSubcategoryResponse,
  ListRequest,
  ListResponseOfPlaceholderSubcategoryListItem,
  ListResponseOfPlaceholderSubcategorySuggestion,
  PlaceholderSubcategoryWriteRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const createProductsPlaceholderSubcategory = (
    placeholderSubcategoryWriteRequest: PlaceholderSubcategoryWriteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/products/placeholder-subcategories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placeholderSubcategoryWriteRequest, signal
    },
      );
    }
  


export const getCreateProductsPlaceholderSubcategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsPlaceholderSubcategory>>, TError,{data: PlaceholderSubcategoryWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProductsPlaceholderSubcategory>>, TError,{data: PlaceholderSubcategoryWriteRequest}, TContext> => {

const mutationKey = ['createProductsPlaceholderSubcategory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductsPlaceholderSubcategory>>, {data: PlaceholderSubcategoryWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  createProductsPlaceholderSubcategory(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProductsPlaceholderSubcategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createProductsPlaceholderSubcategory>>>
    export type CreateProductsPlaceholderSubcategoryMutationBody = PlaceholderSubcategoryWriteRequest
    export type CreateProductsPlaceholderSubcategoryMutationError = ErrorType<unknown>

    export const useCreateProductsPlaceholderSubcategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsPlaceholderSubcategory>>, TError,{data: PlaceholderSubcategoryWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductsPlaceholderSubcategory>>,
        TError,
        {data: PlaceholderSubcategoryWriteRequest},
        TContext
      > => {

      const mutationOptions = getCreateProductsPlaceholderSubcategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const productsPlaceholderSubcategoryList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfPlaceholderSubcategoryListItem>(
      {url: `/api/products/placeholder-subcategories/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getProductsPlaceholderSubcategoryListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsPlaceholderSubcategoryList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsPlaceholderSubcategoryList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['productsPlaceholderSubcategoryList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsPlaceholderSubcategoryList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  productsPlaceholderSubcategoryList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsPlaceholderSubcategoryListMutationResult = NonNullable<Awaited<ReturnType<typeof productsPlaceholderSubcategoryList>>>
    export type ProductsPlaceholderSubcategoryListMutationBody = ListRequest
    export type ProductsPlaceholderSubcategoryListMutationError = ErrorType<unknown>

    export const useProductsPlaceholderSubcategoryList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsPlaceholderSubcategoryList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsPlaceholderSubcategoryList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getProductsPlaceholderSubcategoryListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsPlaceholderSubcategorySuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfPlaceholderSubcategorySuggestion>(
      {url: `/api/products/placeholder-subcategories/suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetProductsPlaceholderSubcategorySuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategorySuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategorySuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getProductsPlaceholderSubcategorySuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getProductsPlaceholderSubcategorySuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getProductsPlaceholderSubcategorySuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetProductsPlaceholderSubcategorySuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getProductsPlaceholderSubcategorySuggestions>>>
    export type GetProductsPlaceholderSubcategorySuggestionsMutationBody = ListRequest
    export type GetProductsPlaceholderSubcategorySuggestionsMutationError = ErrorType<unknown>

    export const useGetProductsPlaceholderSubcategorySuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategorySuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getProductsPlaceholderSubcategorySuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetProductsPlaceholderSubcategorySuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateProductsPlaceholderSubcategory = (
    id: string,
    placeholderSubcategoryWriteRequest: PlaceholderSubcategoryWriteRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/placeholder-subcategories/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: placeholderSubcategoryWriteRequest
    },
      );
    }
  


export const getUpdateProductsPlaceholderSubcategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsPlaceholderSubcategory>>, TError,{id: string;data: PlaceholderSubcategoryWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProductsPlaceholderSubcategory>>, TError,{id: string;data: PlaceholderSubcategoryWriteRequest}, TContext> => {

const mutationKey = ['updateProductsPlaceholderSubcategory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductsPlaceholderSubcategory>>, {id: string;data: PlaceholderSubcategoryWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProductsPlaceholderSubcategory(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductsPlaceholderSubcategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductsPlaceholderSubcategory>>>
    export type UpdateProductsPlaceholderSubcategoryMutationBody = PlaceholderSubcategoryWriteRequest
    export type UpdateProductsPlaceholderSubcategoryMutationError = ErrorType<unknown>

    export const useUpdateProductsPlaceholderSubcategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsPlaceholderSubcategory>>, TError,{id: string;data: PlaceholderSubcategoryWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductsPlaceholderSubcategory>>,
        TError,
        {id: string;data: PlaceholderSubcategoryWriteRequest},
        TContext
      > => {

      const mutationOptions = getUpdateProductsPlaceholderSubcategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsPlaceholderSubcategory = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlaceholderSubcategoryResponse>(
      {url: `/api/products/placeholder-subcategories/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProductsPlaceholderSubcategoryQueryKey = (id?: string,) => {
    return [
    `/api/products/placeholder-subcategories/${id}`
    ] as const;
    }

    
export const getGetProductsPlaceholderSubcategoryQueryOptions = <TData = Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsPlaceholderSubcategoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>> = ({ signal }) => getProductsPlaceholderSubcategory(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsPlaceholderSubcategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>>
export type GetProductsPlaceholderSubcategoryQueryError = ErrorType<void>


export function useGetProductsPlaceholderSubcategory<TData = Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>,
          TError,
          Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsPlaceholderSubcategory<TData = Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>,
          TError,
          Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsPlaceholderSubcategory<TData = Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsPlaceholderSubcategory<TData = Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsPlaceholderSubcategory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsPlaceholderSubcategoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteProductsPlaceholderSubcategory = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/placeholder-subcategories/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductsPlaceholderSubcategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsPlaceholderSubcategory>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductsPlaceholderSubcategory>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteProductsPlaceholderSubcategory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductsPlaceholderSubcategory>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductsPlaceholderSubcategory(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductsPlaceholderSubcategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductsPlaceholderSubcategory>>>
    
    export type DeleteProductsPlaceholderSubcategoryMutationError = ErrorType<unknown>

    export const useDeleteProductsPlaceholderSubcategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsPlaceholderSubcategory>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductsPlaceholderSubcategory>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductsPlaceholderSubcategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    